export default __webpack_public_path__ + "static/lenta_onlain-23117b83cb9c368074b998c82a2ac573.png";